let language = {
    300401: "资源目录不存在",
};

export { language }
